import { useEffect, useState } from "react";

/**
 * useStickyState — useState that persists to localStorage under a stable key.
 * Returns [value, setValue]. Reads initial value lazily.
 *
 *   const [statusFilter, setStatusFilter] = useStickyState("safety:reports:statusFilter", "all");
 */
export function useStickyState(key, defaultValue) {
  const [value, setValue] = useState(() => {
    try {
      const raw = localStorage.getItem(key);
      if (raw === null) return defaultValue;
      return JSON.parse(raw);
    } catch {
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch { /* quota or disabled */ }
  }, [key, value]);

  return [value, setValue];
}
